import styled from 'styled-components';
import { StyledButton } from '../CommonComponents/OPL/Button/Button.styles';

export const PlanSelectionWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  display: flex;
`;

interface SelectedPlanMenuButtonProps {
  hasAccessEditPlans: boolean;
}

export const SelectedPlanMenuButton = styled(StyledButton).attrs({
  variant: 'secondary',
  size: 'medium',
  shape: 'square',
})<SelectedPlanMenuButtonProps>(({ theme, hasAccessEditPlans }) => ({
  height: 64,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  borderRadius: `0 0 ${hasAccessEditPlans ? '0' : theme.radii.medium}px ${theme.radii.medium}px`,
}));

export const SelectedPlanMenuIcon = styled.i`
  position: absolute;
  right: 0;
  margin-right: 22px !important;
`;
